<template>
    <v-card
        :key="item.uid"
        :class="item.className"
        class="gst-notification-container-card card u-box-shadow">
        <v-container
            class="container-layout pt-4 pb-0"
            card-toolbar>
            <v-row
                no-gutters
                style="flex-wrap: nowrap"
                class="pt-0">
                <div class="flex-shrink-1">
                    <component
                        :is="item.icon"
                        height="24"
                        width="24" />
                </div>
                <div class="flex-grow-1">
                    {{ item.title }}
                </div>
                <div
                    v-if="!item.autoDismiss"
                    class="flex-shrink-1">
                    <v-icon
                        size="x-small"
                        class="gst-close-icon-svg"
                        @click="close(item)">
                        mdi-close
                    </v-icon>
                </div>
            </v-row>
        </v-container>
        <v-card-text class="card-text">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <p v-html="item.content"></p>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <p
                v-if="item.footer"
                class="gst-notification-container-card__footer"
                v-html="item.footer"></p>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import IconSuccess from '@assets/icons/alert/success.svg';
import IconInfo from '@assets/icons/alert/info.svg';
import IconError from '@assets/icons/alert/error.svg';
import IconWarning from '@assets/icons/alert/warning.svg';

export default {
    name: 'NotificationContainer',
    components: {
        // eslint-disable-next-line
        IconWarning,
        // eslint-disable-next-line
        IconSuccess,
        // eslint-disable-next-line
        IconInfo,
        // eslint-disable-next-line
        IconError,
    },
    props: {
        item: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    computed: {
        ...mapState(['notification']),
        ...mapGetters({
            hasNotification: 'notification/hasNotification',
        }),
    },
    methods: {
        ...mapActions({
            close: 'notification/close',
        }),
    },
};
</script>
<style lang="scss">
@import '@scssVariables';

$error: theme-color('error');
$success: theme-color('success');
$warning: theme-color('warning');
$info: theme-color('info');

.gst-notification-container-card {
    display: block;
    border: 8px;
    margin-bottom: theme-spacing(5);
    color: theme-color('quaternary');
    max-width: 380px;
    width: 380px;
    padding: theme-spacing(0);

    svg {
        margin-top: -3px;
        margin-right: theme-spacing(2);
    }

    button {
        margin-top: -3px;
    }

    .gst-close-icon-svg {
        ::v-deep .gst-svg-icon {
            fill: theme-color('tertiary');
        }
    }

    .card-toolbar {
        font-weight: font-weight('bold');
        font-size: font-size('l');
        padding: theme-spacing(4) theme-spacing(3) theme-spacing(0) theme-spacing(3);
        overflow: hidden;
        color: theme-color('quaternary');
    }

    .card-text {
        font-size: font-size('s');
        padding-top: theme-spacing(0);
        padding-right: theme-spacing(2);
        padding-left: theme-spacing(11);
        position: relative;
        top: 6px;
        white-space: pre-line;
        color: theme-color('quaternary') !important;

        .gst-notification-container-card__footer {
            margin-top: theme-spacing(2);
            color: theme-color('septenary') !important;
        }
    }

    .notification-close {
        display: block;
    }
}

.gst-notification-container-card.info {
    border-left: 4px solid $info;

    svg .gst-svg-icon {
        fill: $info;
    }
}

.gst-notification-container-card.danger {
    border-left: 4px solid $error;

    svg .gst-svg-icon {
        fill: $error;
    }
}

.gst-notification-container-card.warning {
    border-left: 4px solid $warning;

    svg .gst-svg-icon {
        fill: $warning;
    }
}

.gst-notification-container-card.success {
    border-left: 4px solid $success;

    svg .gst-svg-icon {
        fill: $success;
    }
}
</style>
